import type { EpisodeAvailabilityStatus } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { formatDate } from '@/shared/lib/date';

import { useI18n } from './useI18n';
import { useLocale } from './useLocale';

export function useAvailabilityText(
    timestamp: number | null | undefined,
    availabilityStatus: EpisodeAvailabilityStatus | null | undefined
): string | null {
    const i18n = useI18n();
    const locale = useLocale();

    if (!timestamp) {
        return null;
    }

    const endDate = new Date(timestamp);
    const day = endDate.getDate();
    const month = formatDate(endDate, locale.lang, { month: 'long' });

    if (availabilityStatus === 'PUBLISHED') {
        return i18n('availability__published', { day, month });
    }

    if (availabilityStatus === 'DISABLED') {
        return i18n('availability__disabled', { day, month });
    }

    return null;
}
